import { baseApi as api } from './baseApi';

/** Una pregunta de MercadoLibre sobre una publicación nuestra. */
export interface MeliPregunta {
  preguntaId:   string;
  itemId:       string;
  propertyId:   string | null;
  texto:        string;
  estado:       'pendiente' | 'respondida' | 'cerrada';
  /** `lead` = el contacto automático de ML; `pregunta` = alguien la escribió. */
  tipo:         'lead' | 'pregunta';
  preguntadaEl: string;
  respuesta:    { texto: string; enviadaEl: string } | null;
  /** A la publicación, para verla como la ve el cliente. */
  link:         string;
}

/**
 * Una pregunta en la bandeja de Integraciones: la misma, con quién preguntó (nombre y
 * teléfono, de ML), el agente a cargo y la respuesta precargada. (04/11/2026)
 */
export interface MeliPreguntaBandeja extends Omit<MeliPregunta, 'respuesta'> {
  titulo:    string | null;
  cliente:   { nombre: string | null; telefono: string | null } | null;
  agente:    { id: string; nombre: string; telefono: string | null } | null;
  respuesta: { texto: string; enviadaEl: string; por?: string | null } | null;
  /** Con el agente y su teléfono. Se precarga en el campo; el agente la puede cambiar. */
  sugerida:  string;
}

export const meliPreguntasApi = api.injectEndpoints({
  endpoints: (build) => ({
    getMeliPreguntas: build.query<MeliPregunta[], { propertyId?: string; soloPendientes?: boolean }>({
      query: ({ propertyId, soloPendientes }) => ({
        url: '/integrations/meli/preguntas',
        params: { ...(propertyId ? { propertyId } : {}), ...(soloPendientes === false ? { soloPendientes: 'false' } : {}) },
      }),
      transformResponse: (res: { data: MeliPregunta[] }) => res.data,
      providesTags: ['MeliPreguntas'],
    }),
    /** Las que le tocan a quien mira: las suyas, las de su oficina o las del tenant. */
    getMeliBandeja: build.query<MeliPreguntaBandeja[], { todas?: boolean } | void>({
      // `todas`: también las respondidas y las que se cerraron sin respuesta (el admin las
      // mira para controlar). Sin eso, solo las pendientes: el menú y la home cuentan esas.
      query: (arg) => ({ url: '/integrations/meli/preguntas', params: arg && arg.todas ? { soloPendientes: 'false' } : {} }),
      transformResponse: (res: { data: MeliPreguntaBandeja[] }) => res.data,
      providesTags: ['MeliPreguntas'],
    }),
    responderMeliPregunta: build.mutation<{ ok: boolean }, { preguntaId: string; texto: string }>({
      query: ({ preguntaId, texto }) => ({
        url: `/integrations/meli/preguntas/${preguntaId}/responder`,
        method: 'POST',
        body: { texto },
      }),
      // La respuesta cambia el estado de la pregunta: se recarga la lista de la ficha.
      invalidatesTags: ['MeliPreguntas'],
    }),
  }),
});

export const { useGetMeliPreguntasQuery, useGetMeliBandejaQuery, useResponderMeliPreguntaMutation } = meliPreguntasApi;
